import { FC, useState } from 'react';
import MobileModal from 'v3/common/components/MobileModal';
import Body from './Body';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const BottomNavMore: FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { isB2b, isUserSignedIn } = ApplicationDomainUtility;

  return (
    <div className="bottom-nav-more" onClick={() => setIsOpen(true)}>
      <MobileModal
        isOpen={isOpen}
        className="bottom-nav-more__modal"
        renderHeaderComponent={isB2b && !isUserSignedIn ? 'Please Login To See More Options' : 'More Options'}
        renderContentComponent={<Body />}
        renderFooterComponent={
          <button
            className="btn btn-light btn-rounded"
            onClick={(e) => {
              e.stopPropagation();
              setIsOpen(false);
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M17.625 6.375L6.375 17.625"
                stroke="#B1B1B1"
                strokeWidth="1.875"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6.375 6.375L17.625 17.625"
                stroke="#B1B1B1"
                strokeWidth="1.875"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        }
      />
    </div>
  );
};

export default BottomNavMore;
